import {
  BarChart3,
  Blocks,
  Bot,
  Building2,
  Calendar,
  CalendarCheck,
  CalendarDays,
  CheckSquare,
  Clapperboard,
  Circle,
  Clock,
  ClipboardList,
  DatabaseBackup,
  FileCheck2,
  FileText,
  Fingerprint,
  Folder,
  Handshake,
  History,
  Inbox,
  LayoutDashboard,
  MessageSquare,
  PencilLine,
  Palette,
  Settings,
  ShieldCheck,
  ShoppingCart,
  Users,
  SquarePlay,
  Table2,
  Trophy,
  Tv,
  Video,
  Wallet,
  type LucideIcon,
  type LucideProps,
} from 'lucide-react';
import { createElement } from 'react';

/**
 * Icons that manifests may reference by name. An explicit map keeps unused icons out of the bundle;
 * add an entry here when a module needs a new icon.
 */
const ICONS: Record<string, LucideIcon> = {
  'bar-chart': BarChart3,
  blocks: Blocks,
  bot: Bot,
  building: Building2,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-days': CalendarDays,
  'check-square': CheckSquare,
  clapperboard: Clapperboard,
  'clipboard-list': ClipboardList,
  clock: Clock,
  'database-backup': DatabaseBackup,
  'file-check': FileCheck2,
  'file-text': FileText,
  fingerprint: Fingerprint,
  folder: Folder,
  handshake: Handshake,
  history: History,
  inbox: Inbox,
  'layout-dashboard': LayoutDashboard,
  'message-square': MessageSquare,
  palette: Palette,
  'pencil-line': PencilLine,
  settings: Settings,
  'shield-check': ShieldCheck,
  'shopping-cart': ShoppingCart,
  table: Table2,
  trophy: Trophy,
  tv: Tv,
  users: Users,
  video: Video,
  wallet: Wallet,
  // lucide no longer ships brand logos; a neutral "play" glyph stands in for YouTube.
  youtube: SquarePlay,
};

/** Renders the icon registered under `name` (a manifest's `icon`), or a neutral dot when unknown. */
export function NavIcon({ name, ...props }: LucideProps & { name: string | undefined }) {
  return createElement((name && ICONS[name]) || Circle, props);
}
